export default [
  {
    Link: "https://www.instagram.com/reel/DFp9pGvzn1P/?igsh=ZjFkYzMzMDQzZg%3D%3D",
    Desc: "SAE ZHCET’s Computational Fluid Dynamics (CFD) Workshop using ANSYS & SimScale was a powerhouse of learning, innovation, and hands-on experience. 💡💻",
    Title: "CFD Workshop 2024",
  },
  {
    Link: "https://www.instagram.com/reel/C_Fx9NHSXfW/?igsh=MWZyOXF0MWFrM2kzMg%3D%3D",
    Desc: "Revving up for an exciting year! 🏁🏎️The event was a success with the gathering of faculty advisors, Respected principal and chairman mechanical engineering department, and of course racing enthusiasts eagerly awaiting the unveiling of club details and ready to accelerate into year of innovation and passion",
    Title: "Orientation Ceremony of 2024",
  },

  {
    Link: "https://www.instagram.com/p/DFrkMLNTjYx/?igsh=OXg3MnZmam9zYndm&img_index=1",
    Desc: "SAE ZHCET Just made headlines,A heartfelt thank you to Education Ministry of India & Hon'ble Shri Dharmendra Pradhan for recognizing SAE ZHCET’s dedication to innovation and excellence. Your support inspires us to push further, dream bigger, and drive the future of engineering. This is just the beginning—greater milestones await!🏎️💫",
    Title: "Ministry of Education program",
  },
  {
    Link: "https://www.instagram.com/p/Cj8YmaVynE8/?igshid=YmMyMTA2M2Y=",
    Desc: "SAE-ZHCET is delighted to inform you that all of the alumni and officials in attendance saw our work on exhibit during the World Alumni Meet.",
    Title: "World Alumni Meet 2022",
  },
  {
    Link: "https://www.instagram.com/p/Ckoaw3ZSGXS/?igshid=YmMyMTA2M2Y=",
    Desc: "SAE ZHCET Collegiate Club organized an orientation ceremony for the session 2022-23 catering to the newly admitted students of the college.",
    Title: "Orientation Ceremony",
  },
  {
    Link: "https://indiaeducationdiary.in/zhcet-team-wins-top-prizes-for-their-formula-car/",
    Desc: "Revving the sound of engines and screeching its tyres, ‘ZFR 5.0’ was greeted with cheers of wonderstruck chassis constructors and automobile ..",
    Title: "Formula Imperial 2022",
  },
  {
    Link: "https://www.amu.ac.in/hi/news/2022/07/19/amu-team-get-top-ranks-for-designing-formula-electric-car",
    Desc: "AMU Team get top ranks for designing Electric Formula Car..",
    Title: "Pi-EV Results 2022 - ZFR EV",
  },
  {
    Link: "https://www.amu.ac.in/news/2022/06/29/new-society-of-automotive-engineers-collegiate-club-office-bearers-take-charge",
    Desc: "New Society of Automotive Engineers Collegiate Club takes charge ...",
    Title: "Installation Ceremony - SAE ZHCET",
  },
];
